import { render, staticRenderFns } from "./fangwuGuiPersonInfo.vue?vue&type=template&id=44c37466&scoped=true&"
import script from "./fangwuGuiPersonInfo.vue?vue&type=script&lang=js&"
export * from "./fangwuGuiPersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./fangwuGuiPersonInfo.vue?vue&type=style&index=0&id=44c37466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c37466",
  null
  
)

export default component.exports